import { Button } from "@/components/common";
import { KeycloakService } from "@/services/keycloakService";

interface LoginButtonProps {
  className?: string;
  variant?: "primary" | "secondary" | "danger" | "ghost";
  size?: "sm" | "md" | "lg";
}

export const LoginButton: React.FC<LoginButtonProps> = ({
  className = "",
  variant = "primary",
  size = "md",
}) => {
  const handleLogin = () => {
    KeycloakService.redirectToLogin();
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleLogin}
      className={className}
    >
      Entrar com Keycloak
    </Button>
  );
};
